import { GripVertical, Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function TemplateItemsEditor({
	items,
	onChange,
	disabled,
}: {
	items: string[];
	onChange: (items: string[]) => void;
	disabled?: boolean;
}) {
	function updateAt(index: number, value: string) {
		onChange(items.map((it, i) => (i === index ? value : it)));
	}

	function removeAt(index: number) {
		onChange(items.filter((_, i) => i !== index));
	}

	function addRow() {
		onChange([...items, ""]);
	}

	return (
		<div className="space-y-2">
			{items.map((it, i) => (
				<div key={i} className="flex items-center gap-2">
					<GripVertical className="h-3.5 w-3.5 text-muted shrink-0" />
					<Input
						value={it}
						disabled={disabled}
						placeholder={`Item ${i + 1}`}
						onChange={(e) => updateAt(i, e.target.value)}
						className="h-8 text-sm flex-1"
					/>
					<button
						type="button"
						onClick={() => removeAt(i)}
						disabled={disabled}
						aria-label="Remove item"
						className="text-muted hover:text-danger transition-colors shrink-0 disabled:opacity-40"
					>
						<X className="h-4 w-4" />
					</button>
				</div>
			))}
			<Button
				type="button"
				variant="ghost"
				size="sm"
				onClick={addRow}
				disabled={disabled}
			>
				<Plus className="h-3.5 w-3.5 mr-1.5" />
				Add item
			</Button>
		</div>
	);
}
